import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { INpmiPublicNoticePlaylist } from '../../types/api-response/npmi-public-notice';

@Injectable()
export class NpmiApiService {

    constructor(private http: HttpClient) {
    }

    /**
     * Returns playlist notices
     * for selected postal code
     *
     * @param postalCode
     */
    public getPublicNoticePlaylist(postalCode): Observable<INpmiPublicNoticePlaylist> {
        const url = `https://announcements.maxtv.media/announcements/${postalCode}`;

        return this.http.get(url).pipe(
            map((result: any) => result.length ? result[0].playlists[0] : []),
            catchError(result => of([])) // ignore any error and return empty array as result instead
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/npmi-api.service.ts